module.exports = __webpack_public_path__ + "assets/img/news (30).81ca2f87.png";